/*
 * LICENSE PROTECTED SOFTWARE
 * (c) 2026  @cemdemirci0101
 * (c) 2026 All Rights Reserved.
 */

import LoginPage from "./pages/LoginPage";
import HomePage from "./pages/HomePage";
import KurumsalPage from "./pages/KurumsalPage";
import DashboardPage from "./pages/DashboardPage";
import { TicketsListPage, NewTicketPage, NewProjectPage, TicketDetailPage } from "./pages/TicketsPage";
import { STKListPage, STKApplicationForm } from "./pages/STKPage";
import STKDetailPage from "./pages/STKDetailPage";
import { MeetingsListPage, NewMeetingPage } from "./pages/MeetingsPage";
import MeetingDetailPage from "./pages/MeetingDetailPage";
import { AnnouncementsListPage, NewAnnouncementPage } from "./pages/AnnouncementsPage";
import AnnouncementDetailPage from "./pages/AnnouncementDetailPage";
import { UsersListPage } from "./pages/UsersPage";
import OrgansPage from "./pages/OrgansPage";
import WorkingGroupsPage from "./pages/WorkingGroupsPage";
import ProfilePage from "./pages/ProfilePage";
import NotificationsPage from "./pages/NotificationsPage";
import RBACPage from "./pages/RBACPage";
import AuditLogsPage from "./pages/AuditLogsPage";
import SmtpSettingsPage from "./pages/SmtpSettingsPage";
import PasswordResetPage from "./pages/PasswordResetPage";
import SurveysPage from "./pages/SurveysPage";
import SurveyBuilderPage from "./pages/SurveyBuilderPage";
import SurveyTakePage from "./pages/SurveyTakePage";
import SurveyResultsPage from "./pages/SurveyResultsPage";
import { EventsListPage, NewEventPage, EventDetailPage } from "./pages/EventsPage";
import DeletedAccountsPage from "./pages/DeletedAccountsPage";
import MuhtarApplicationsPage from "./pages/MuhtarApplicationsPage";
import StatisticsPage from "./pages/StatisticsPage";
import PendingKkApprovalPage from "./pages/PendingKkApprovalPage";
import CookiePolicyPage from "./pages/CookiePolicyPage";
import PrivacyNoticePage from "./pages/PrivacyNoticePage";
import DataBreachPage from "./pages/DataBreachPage";
import STKDocumentRequestsPage from "./pages/STKDocumentRequestsPage";

// Public routes (no auth)
export const publicRoutes = [
  { path: "/", element: HomePage },
  { path: "/kurumsal", element: KurumsalPage },
  { path: "/giris", element: LoginPage },
  { path: "/login", element: LoginPage },
  { path: "/dogrula", element: LoginPage },
  { path: "/sifre-sifirla", element: PasswordResetPage },
  { path: "/cerez-politikasi", element: CookiePolicyPage },
  { path: "/gizlilik-bildirimi", element: PrivacyNoticePage },
  { path: "/kvkk", element: PrivacyNoticePage },
];

// Dashboard routes (auth required, wrapped with DashboardLayout)
export const dashboardRoutes = [
  { path: "/panel", element: DashboardPage },
  { path: "/panel/talepler", element: TicketsListPage },
  { path: "/panel/talepler/yeni", element: NewTicketPage },
  { path: "/panel/talepler/proje-onerisi", element: NewProjectPage },
  { path: "/panel/talepler/:ticketId", element: TicketDetailPage, useParams: true },
  { path: "/panel/stk", element: STKListPage },
  { path: "/panel/stk/basvuru", element: STKApplicationForm },
  { path: "/panel/stk/:appId", element: STKDetailPage },
  { path: "/panel/toplantilar", element: MeetingsListPage },
  { path: "/panel/toplantilar/yeni", element: NewMeetingPage },
  { path: "/panel/toplantilar/:meetingId/duzenle", element: NewMeetingPage },
  { path: "/panel/toplantilar/:meetingId", element: MeetingDetailPage },
  { path: "/panel/duyurular", element: AnnouncementsListPage },
  { path: "/panel/duyurular/yeni", element: NewAnnouncementPage },
  { path: "/panel/duyurular/:announcementId/duzenle", element: NewAnnouncementPage },
  { path: "/panel/duyurular/:announcementId", element: AnnouncementDetailPage },
  { path: "/panel/kullanicilar", element: UsersListPage },
  { path: "/panel/organlar", element: OrgansPage },
  { path: "/panel/calisma-gruplari", element: WorkingGroupsPage },
  { path: "/panel/bildirimler", element: NotificationsPage },
  { path: "/panel/roller", element: RBACPage },
  { path: "/panel/loglar", element: AuditLogsPage },
  { path: "/panel/smtp-ayarlari", element: SmtpSettingsPage },
  { path: "/panel/anketler", element: SurveysPage },
  { path: "/panel/anketler/olustur", element: SurveyBuilderPage },
  { path: "/panel/anketler/:surveyId/yanitle", element: SurveyTakePage },
  { path: "/panel/anketler/:surveyId/sonuclar", element: SurveyResultsPage },
  { path: "/panel/etkinlikler", element: EventsListPage },
  { path: "/panel/etkinlikler/yeni", element: NewEventPage },
  { path: "/panel/etkinlikler/:id", element: EventDetailPage },
  { path: "/panel/profil", element: ProfilePage },
  { path: "/panel/ayarlar", element: ProfilePage },
  { path: "/panel/silinmis-hesaplar", element: DeletedAccountsPage },
  { path: "/panel/muhtar-basvurulari", element: MuhtarApplicationsPage },
  { path: "/panel/istatistikler", element: StatisticsPage },
  { path: "/panel/kullanicilar/onay-bekleyen", element: PendingKkApprovalPage },
  { path: "/panel/veri-ihlali", element: DataBreachPage },
  { path: "/panel/stk/belge-talepleri", element: STKDocumentRequestsPage },
];
